import styles from './baseInfo.module.scss'
import { useEffect, useState } from 'react'
import { Upload, message, Button, Flex, Checkbox } from 'antd';
import { LoadingOutlined, PlusOutlined, EditOutlined } from '@ant-design/icons';
import ImgCrop from 'antd-img-crop';
import profile from "@/assets/images/profile.png"
import { userDetail, updateUser, followStats, changeEmailStatus } from "@/apis/user";
import { fileUpload } from "@/apis/public";
import { CameraOutlined, IdcardOutlined, EnvironmentOutlined, CarryOutOutlined, UsergroupDeleteOutlined, MailOutlined, SearchOutlined } from '@ant-design/icons'
import InputModal from "./inputModal";
import ChangeEmail from './changeEmail';
import UpdataPassword from './updataPassword'
import { useDispatch } from "react-redux";
import { setUserInfo, setAvatar } from "@/store/modules/user";
import { useNavigate } from "react-router-dom";
import intl from "react-intl-universal";
import Follow from './Follow';
import OgeAccount from './ogeAccount';
import ModelConfig from './modelConfig';
import DefaultModelQuota from './defaultModelQuota';

const getBase64 = (img, callback) => {
	const reader = new FileReader();
	reader.addEventListener('load', () => callback(reader.result));
	reader.readAsDataURL(img);
};
const beforeUpload = (file) => {
	const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
	if (!isJpgOrPng) {
		message.error('You can only upload JPG/PNG file!');
	}
	const isLt5M = file.size / 1024 / 1024 < 5;
	if (!isLt5M) {
		message.error('Image must smaller than 2MB!');
	}
	return isJpgOrPng && isLt5M;
};
const BaseInfo = () => {
	const [isOpen, setIsOpen] = useState(false); // 普通信息弹窗
	const [isChange, setIsChange] = useState(false);  // 更换绑定邮箱弹窗
	const [isPassword, setIsPassword] = useState(false); // 更改密码弹窗
	const [imageUrl, setImageUrl] = useState(profile);
	const [loading, setLoading] = useState(false);
	const [userInfos, setUserInfos] = useState({});
	const [isUpdate, setIsUpdata] = useState(false);
	const [open, setOpen] = useState(false);
	const [title, setTitle] = useState('');

	const [followerCount, setFollowerCount] = useState(0)
	const [followingCount, setFollowingCount] = useState(0)
	const [checked, setChecked] = useState(false);

	const dispatch = useDispatch()
	const navigate = useNavigate()

	const customRequest = (options) => {
		const { onSuccess, file } = options;
		onSuccess('上传成功', file);
	}
	const handleChange = (info) => {
		if (info.file.status === 'uploading') {
			setLoading(true);
			return;
		}
		if (info.file.status === 'done') {
			getBase64(info.file.originFileObj, (url) => {
				setLoading(false);
				setImageUrl(url);
			});
			const formData = new FormData()
			formData.append("multipartFiles", info.file.xhr)
			formData.append("secondType", "AvatarPicture")
			fileUpload(formData).then(res => {
				//修改头像信息
				const params = {
					avatarFileUuid: res.data[0].fileUuid
				}
				updateUserInfo(params)
			}).catch(err => {
			})
		}
	}
	// 修改用户信息
	const updateUserInfo = (params) => {
		updateUser(params).then(res => {
			message.success('更换成功')
			setIsUpdata(!isUpdate)

		}).catch(err => {
		})
	}
	useEffect(() => {
		// 获取用户详情信息
		const getDetail = () => {
			userDetail().then(res => {
				const result = res?.data
				setChecked(result?.isDisplay || false)
				setUserInfos({
					username: result?.username,
					nickname: result?.nickname,
					email: result?.email,
					realName: result?.firstName + "," + result?.lastName,
					uuid: result?.uuid,
					organization: result?.organization,
					country: result?.country,
					createTime: result?.createTime,
					researchAspect: result?.researchAspect,
					signature: result?.signature,
				})
				if (result?.avatar?.filePath) {
					setImageUrl(process.env.REACT_APP_API_AFFIX + "/file/preview?filePath=" + result.avatar.filePath)
					dispatch(setAvatar(result?.avatar?.filePath))
				}
			})
		}
		getDetail()
		followStats().then(res => {
			setFollowerCount(res.data.followerCount || 0)
			setFollowingCount(res.data.followingCount || 0)
		})
	}, [dispatch, isUpdate])

	const openList = (type, title) => {
		setOpen(true)
		setTitle(title)

	}
	const changeFollow = (type, status) => {
		// 保留type  为移除粉丝做准备
		if (type === "followedByMe") {
			if (status) {
				// 关注
				setFollowingCount(followingCount + 1)
			} else {
				// 取关
				setFollowingCount(followingCount - 1)
			}
		}
	}

	const changeEmailIsShow = (e) => {
		changeEmailStatus({
			isDisplay: e.target.checked,
		}).then(res => {
			setChecked(e.target.checked);
		})
	}

	const uploadButton = (
		<button
			style={{
				border: 0,
				background: 'none',
			}}
			type="button"
		>
			{loading ? <LoadingOutlined /> : <PlusOutlined />}
			<div
				style={{
					marginTop: 8,
				}}
			>
				Upload
			</div>
		</button>
	);
	return <div className={styles.baseInfoBox}>
		{/*<h3>{intl.get("Basic Information")}</h3>*/}
		<div className={styles.avatarFrameBox}>
			<ImgCrop
				rotationSlider={false}
				cropShape='round'
			>
				<Upload
					name="avatar"
					listType="picture-circle"
					className="avatar-uploader"
					showUploadList={false}
					action="#"
					beforeUpload={beforeUpload}
					customRequest={customRequest}
					onChange={handleChange}
					accept=".png, .jpg, .jpeg,webp"
				>
					{imageUrl ? <img src={imageUrl} alt="avatar" className={styles.imgBox} style={{ width: '100%' }} /> : uploadButton}
					<CameraOutlined className={styles.cameraBox} />
				</Upload>
			</ImgCrop>
		</div>
		<div className={styles.userBox}>{userInfos.nickname}</div>

		<div className={styles.signatureBox}>
			{userInfos.signature ? <span title={userInfos.signature}>{userInfos.signature}</span>
				: <span onClick={() => { setIsOpen(true) }}>
					{intl.get("User.Add a bio")}
					<EditOutlined />
				</span>
			}
		</div>

		<Flex className={styles.ecologyBox} justify="space-around">
			<div onClick={() => openList(1, "Following")}>
				<span>{intl.get("User.Following")}</span>
				<div>{followingCount}</div>
			</div>
			<div onClick={() => openList(2, "Followers")}>
				<span>{intl.get("User.Followers")}</span>
				<div>{followerCount}</div>
			</div>
		</Flex>

		<div className={styles.moreInfoBox}>
			<div className='flex_box align_top'>
				<div>
					<IdcardOutlined />
					<i>{intl.get('User.Username')}：</i>
				</div>
				<span>{userInfos.username}</span>
			</div>
			<div className='flex_box align_top'>
				<div>
					<EnvironmentOutlined />
					<i>{intl.get('Register.Country/Region')}：</i>
				</div>
				<span>{userInfos.country}</span>
			</div>
			<div className='flex_box align_top'>
				<div>
					<CarryOutOutlined />
					<i>{intl.get("Registration time")}：</i>
				</div>
				<span>{userInfos.createTime}</span>
			</div>
			<div className='flex_box align_top'>
				<div>
					<UsergroupDeleteOutlined />
					<i>{intl.get("Register.Organization")}：</i>
				</div>
				<span>{userInfos.organization}</span>
			</div>
			<div className='flex_box align_top'>
				<div>
					<SearchOutlined />
					<i>{intl.get("Register.Research aspect")}：</i>
				</div>
				<span>{userInfos.researchAspect}</span>
			</div>
			<div className='flex_box align_top'>
				<div>
					<MailOutlined />
					<i>{intl.get("Email")}：</i>
				</div>
				<span>{userInfos.email}</span>
			</div>

			<div className='flex_box align_top'>
				<Checkbox checked={checked} onChange={changeEmailIsShow}>对外展示邮箱</Checkbox>
			</div>
		</div>
		<div>

			<Button
				onClick={() => { setIsChange(true) }}
				type="link"
			>
				{intl.get("Change Bound Email")}
			</Button>

			<Button
				onClick={() => { setIsOpen(true) }}
				type="link"
			>
				{intl.get("Edit Information")}
			</Button>
		</div>
		<OgeAccount />
		<DefaultModelQuota />
		<ModelConfig />
		<Button
			onClick={() => { setIsPassword(true) }}
			className={styles.btnBox}
			type="primary"
			block
		>
			{intl.get('Change Password')}
		</Button>
		<Button onClick={() => {
			dispatch(setUserInfo({
				username: '',
				token: '',
				refreshToken: "",
				roleId: "",
				password: "",
				nickname: "",
				uuid: ""
			}))
			localStorage.clear()
			navigate('/')
		}} block>{intl.get('User.Sign out')}</Button>
		<InputModal isOpen={isOpen} setIsOpen={setIsOpen} userInfo={userInfos} isUpdate={isUpdate} setIsUpdata={setIsUpdata} />
		<ChangeEmail isChange={isChange} setIsChange={setIsChange} email={userInfos.email} uuid={userInfos.uuid} isUpdate={isUpdate} setIsUpdata={setIsUpdata} />
		<UpdataPassword isPassword={isPassword} uuid={userInfos.uuid} setIsPassword={setIsPassword} />
		<div className={styles.emailBox}>{intl.get('baseDes')}<a href="mailto:info@ogeoa.net">info@ogeoa.net</a></div>

		<Follow open={open} setOpen={setOpen} title={title} changeFollow={changeFollow} />

	</div>
}
export default BaseInfo;
